import React, { useState } from 'react';
import SocialPublicacoes from './SocialPublicacoes';
import SocialOutreach from './SocialOutreach';
import SocialComentarios from './SocialComentarios';

type Aba = 'publicacoes' | 'networking' | 'comentarios';

const RedesSociais: React.FC = () => {
  const [aba, setAba] = useState<Aba>('publicacoes');

  return (
    <div>
      <div style={styles.subnav}>
        <button
          onClick={() => setAba('publicacoes')}
          style={{ ...styles.tab, ...(aba === 'publicacoes' ? styles.tabAtiva : {}) }}
        >
          Publicações
        </button>
        <button
          onClick={() => setAba('networking')}
          style={{ ...styles.tab, ...(aba === 'networking' ? styles.tabAtiva : {}) }}
        >
          Networking IG
        </button>
        <button
          onClick={() => setAba('comentarios')}
          style={{ ...styles.tab, ...(aba === 'comentarios' ? styles.tabAtiva : {}) }}
        >
          Comentários
        </button>
      </div>

      {aba === 'publicacoes' && <SocialPublicacoes />}
      {aba === 'networking' && <SocialOutreach />}
      {aba === 'comentarios' && <SocialComentarios />}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  subnav: {
    display: 'flex',
    gap: 8,
    marginBottom: 20,
    borderBottom: '1px solid rgba(255,255,255,0.1)',
    paddingBottom: 12,
  },
  tab: {
    background: 'transparent',
    border: '1px solid #ff6600',
    color: '#ff6600',
    padding: '8px 20px',
    borderRadius: 20,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
  },
  tabAtiva: {
    background: '#ff6600',
    color: '#fff',
  },
};

export default RedesSociais;
